import { Rfc4646LanguageCodes } from "@rsm-hcd/javascript-core";

export const SupportedCultures = [
    Rfc4646LanguageCodes.EN_US,
    Rfc4646LanguageCodes.ES_ES,
];
